import { useMemo } from 'react'

import { QUICK_LINKS } from '@/defs/nav'
import { useReduxSelector } from '@/store/hooks'
import { selectors } from '@/store/selectors'

export const useQuickLinks = () => {
  const patreonTier = useReduxSelector(selectors.patreonTier)

  return useMemo(
    () => (patreonTier ? QUICK_LINKS.filter(({ variant }) => variant !== 'patreon') : QUICK_LINKS),
    [patreonTier],
  )
}
